export default __webpack_public_path__ + "static/media/Portraits-Long.27e0668c.jpg";